import { relations } from 'drizzle-orm';
import { boolean, pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core';
import { uuidv7 } from './utils/uuidv7.js';
import { organisation } from './organisation.js';
import { timestamps } from './utils/index.js';
export const organisationUser = pgTable('organisation_user', {
    id: uuidv7('id').primaryKey(),
    organisationId: uuid('organisation_id')
        .notNull()
        .references(() => organisation.id, { onDelete: 'cascade', onUpdate: 'cascade' }),
    userId: text('user_id').notNull(),
    username: text('username'),
    email: text('email').notNull(),
    firstName: text('first_name'),
    lastName: text('last_name'),
    groups: text('groups').array().notNull().default([]),
    active: boolean('active').notNull(),
    snapshotGeneratedAt: timestamp('snapshot_generated_at').notNull(),
    ...timestamps(),
}, t => [uniqueIndex().on(t.organisationId, t.userId)]);
export const organisationUsersRelations = relations(organisationUser, ({ one }) => ({
    organisation: one(organisation, { fields: [organisationUser.organisationId], references: [organisation.id] }),
}));
//# sourceMappingURL=organisation-user.js.map